export default __webpack_public_path__ + "static/media/remeeting-logo-blue-gray.33db1f19.svg";